import React, { useState, useEffect } from "react";
import {
  FaMobileAlt,
  FaEnvelope,
  FaClock,
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
  FaPinterest,
  FaSearch,
  FaTimes,
  FaArrowRight,
  FaBars,
} from "react-icons/fa";
// import logo from "../assets/images/logo.jpeg";
import logo from "../assets/images/sveil/logo.jpeg";
import { NavLink } from "react-router-dom";

export const Header = () => {
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);
  const [isSmallNav, setIsSmallNav] = useState(window.innerWidth <= 991);
  const [isSticky, setIsSticky] = useState(false);

  const toggleMobileNav = () => {
    setIsMobileNavOpen(!isMobileNavOpen);
    document.body.classList.toggle("body-overlay", !isMobileNavOpen);
  };

  const handleResize = () => {
    setIsSmallNav(window.innerWidth <= 991);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleSubMenuToggle = (e) => {
    if (isSmallNav) {
      e.preventDefault();
      e.currentTarget.nextElementSibling?.classList.toggle("open");
    }
  };
  return (
    <div>
      <header id="header" className="site-header header-style-2">
        <div className="topbar">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-9">
                <div className="contact-info">
                  <ul className="list-inline mb-0">
                    <li className="list-inline-item">
                      <FaMobileAlt />
                      +91 9390332035, +91 9391646324
                    </li>
                    <li className="list-inline-item">
                      <FaEnvelope /> srivenkateswara148@gmail.com
                    </li>
                    {/* <li className="list-inline-item">
                      <FaClock /> Mon - Sat 10AM - 7PM
                    </li> */}
                  </ul>
                </div>
              </div>
              <div className="col-md-3">
                <div className="social">
                  <ul className="list-inline mb-0">
                    {/* <li className="list-inline-item">
                      <NavLink href="#">
                        <FaFacebookF />
                      </NavLink>
                    </li>
                    <li className="list-inline-item">
                      <NavLink href="#">
                        <FaTwitter />
                      </NavLink>
                    </li>
                    <li className="list-inline-item">
                      <NavLink href="#">
                        <FaLinkedinIn />
                      </NavLink>
                    </li>
                    <li className="list-inline-item">
                      <NavLink href="#">
                        <FaPinterest />
                      </NavLink>
                    </li> */}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <nav
          className={`navigation navbar navbar-default ${
            isSticky ? "sticky-on" : ""
          }`}
        >
          <div className="container">
            <div className="navbar-header">
              <button
                type="button"
                className="open-btn"
                onClick={toggleMobileNav}
              >
                <span className="sr-only">Toggle navigation</span>
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
              </button>
              <NavLink className="navbar-brand" to="/">
                {/* <img src="../assets/images/logo-2.png" alt /> */}
                <img src={logo} alt />
              </NavLink>
            </div>
            <div
              id="navbar"
              className={`navbar-collapse collapse navbar-right navigation-holder ${
                isMobileNavOpen ? "slideInn" : ""
              }`}
            >
              <button className="close-navbar" onClick={toggleMobileNav}>
                {/* <i className="ti-close"></i> */}
                <FaTimes />
              </button>
              <ul className={`nav navbar-nav ${isSmallNav ? "small-nav" : ""}`}>
                <li className="menu-item-has-children">
                  <NavLink to="/">Home</NavLink>
                </li>
                <li className="menu-item-has-children">
                  <a href="#" onClick={handleSubMenuToggle}>
                    Corporate
                  </a>
                  <ul className="sub-menu">
                    <li>
                      <NavLink to="/aboutus">About SVEIL</NavLink>
                    </li>
                    <li>
                      <NavLink to="/code-of-conduct">Code of Conduct</NavLink>
                    </li>
                    <li>
                      <NavLink to="/#">Careers</NavLink>
                    </li>
                    <li>
                      <NavLink to="/#">Press Release</NavLink>
                    </li>
                 
                  </ul>
                </li>
                <li className="menu-item-has-children">
                  <NavLink to="/aboutus">About Us</NavLink>
                </li>
                {/* <li className="menu-item-has-children">
                  <NavLink to="/">Latest News</NavLink>
                </li> */}
                  <li className="menu-item-has-children">
                  <a href="/business-units" onClick={handleSubMenuToggle}>
                   Business Units
                  </a>
                  <ul className="sub-menu">
                    <li>
                      <NavLink to="/#">Aquaculture Division</NavLink>
                    </li>
                    <li>
                      <NavLink to="/#">Poultry Division</NavLink>
                    </li>
                    <li>
                      <NavLink to="/#">Mining Division</NavLink>
                    </li>
                    <li>
                      <NavLink to="/#">Infrastructure & Construction Division</NavLink>
                    </li>
                      <li>
                      <NavLink to="/#">Real Estate Development Division</NavLink>
                    </li>
                      <li>
                      <NavLink to="/#">Renewable Energy Division</NavLink>
                    </li>
                 
                  </ul>
                </li>
              
                <li className="menu-item-has-children">
                  <NavLink to="/success-stories">Success Stories</NavLink>
                </li>
                {/* <li className="menu-item-has-children">
                  <NavLink to="/blog">Blog</NavLink>
                </li> */}
                <li>
                  <NavLink to="/contact">Contact</NavLink>
                </li>
              </ul>
            </div>

            <div className="search-contact">
              <div className="contact-btn">
                <NavLink to="/contact">
                  <div className="theme-btn">Get a quote</div>
                </NavLink>
              </div>
            </div>
          </div>
        </nav>
      </header>
    </div>
  );
};
